import React from 'react';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import ServiceHealth from './ServiceHealth';


const ServiceHealthAdmin = (props) => {

    const { themeSelected } = props;

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <ServiceHealth className='mt-3' themeSelected={themeSelected} />
        </div>
    )
}

export default ServiceHealthAdmin;